import {
    clearAuxResourceName,
    clearAuxResourceUrl,
    clearExperienceMarker, clearGeoData, clearMapBounds,
    setGeoData, setMapBounds, setMapFilter, setNavOpen,
    setNavOption, setPrevNavOption, setTitle
} from "./commit_helpers";

// Use this function when a navOption is selected - could be via a user action (click), url loading or other event triggering.
export function selectNavOption(sm, navOption) {

    if (navOption.mapBounds && sm.state['renderMapBounds'] === true) {
        setMapBounds(sm, navOption.mapBounds);
    } else {
        clearMapBounds(sm);
    }

    if (navOption.hasGeoData()) {
        navOption.getGeoData().then((geoData)=>{
            if (typeof geoData == 'object') setGeoData(sm, geoData);
        });
    } else {
        clearGeoData(sm);
    }

    // The map filter is the new nav option's map filter or whatever the current one is.
    // When the nav option is a subpage it won't have a map filter so we continue to use the current one in state or the default one for the online app.
    const mapFilter = navOption.mapFilter || sm.state['mapFilter'] || navOption.onlineApp.defaultMapFilter();
    if (mapFilter) {
        setTitle(sm, mapFilter.getMapTitle());
        setMapFilter(sm, mapFilter);
        setPrevNavOption(sm, null); // clear the prev nav option so that closing the Aux doesn't change the navOption
    }

    // If we're not `modal` then we should never close the Nav.
    // If we're `modal` then the focus might want to be on the map, so we'd close the nav.
    if (sm.state['modal']) {
        let shouldCloseNav = navOption.shouldCloseNav();
        setNavOpen(sm, !shouldCloseNav);
    }

    clearExperienceMarker(sm);
    clearAuxResourceUrl(sm);
    clearAuxResourceName(sm);

    setNavOption(sm, navOption);
}
